"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSearchResultLoading = void 0;
const React = require("react");
const react_instantsearch_1 = require("react-instantsearch");
const useSearchResultLoading = (tiles, isTabZeroResult, isContentTranslationLoading, isProductExtraDataLoading, isFilterTranslationsLoading, isHitsAndFiltersLoading, isTabsLoading, setIsHitsAndFiltersLoading) => {
    const { status } = (0, react_instantsearch_1.useInstantSearch)();
    const [isHitsLoading, setIsHitsLoading] = React.useState(false);
    const [hasError, setHasError] = React.useState(false);
    const isLoading = React.useMemo(() => status === 'loading' || status === 'stalled', [status]);
    React.useEffect(() => {
        if (status === 'error') {
            setHasError(true);
            setIsHitsLoading(false);
            setIsHitsAndFiltersLoading(false);
        }
    }, [status]);
    React.useEffect(() => {
        if (!isLoading &&
            !isContentTranslationLoading &&
            !isProductExtraDataLoading &&
            !isFilterTranslationsLoading &&
            !isTabsLoading) {
            if (isHitsLoading) {
                setIsHitsLoading(false);
            }
            if (isHitsAndFiltersLoading) {
                setIsHitsAndFiltersLoading(false);
            }
        }
    }, [
        isLoading,
        tiles.length,
        isTabZeroResult,
        isTabsLoading,
        isHitsLoading,
        isHitsAndFiltersLoading,
        isFilterTranslationsLoading,
        isContentTranslationLoading,
        isProductExtraDataLoading,
    ]);
    return {
        isLoading,
        isHitsLoading,
        isHitsAndFiltersLoading,
        hasError,
        setIsHitsLoading,
        setIsHitsAndFiltersLoading,
    };
};
exports.useSearchResultLoading = useSearchResultLoading;
